import { render, staticRenderFns } from "./StockDamage.vue?vue&type=template&id=1ca6c44d"
import script from "./StockDamage.vue?vue&type=script&lang=js"
export * from "./StockDamage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports